import { render, staticRenderFns } from "./unExpiredFile.vue?vue&type=template&id=91094dd2&scoped=true&"
import script from "./unExpiredFile.vue?vue&type=script&lang=ts&"
export * from "./unExpiredFile.vue?vue&type=script&lang=ts&"
import style0 from "./unExpiredFile.vue?vue&type=style&index=0&id=91094dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91094dd2",
  null
  
)

export default component.exports